<template>
    <VDialog v-bind="$attrs" class="sr-modal" @click:outside="close" @keydown.esc="close">
        <VCard class="sr-modal-card">
            <SrButton v-if="closable" class="sr-modal-close-icon-wrapper" icon small color="grey" @click="close">
                <SrIcon icon="close" size="xxs" />
            </SrButton>

            <VCardTitle class="sr-modal-card-title">
                <slot name="header" />
            </VCardTitle>

            <VCardText class="sr-modal-card-text">
                <slot />
            </VCardText>

            <VCardActions class="sr-modal-card-actions">
                <slot name="footer" />
            </VCardActions>
        </VCard>
    </VDialog>
</template>

<script>
import SrIcon from '../SrIcon/SrIcon';

export default {
    name: 'SrModal',
    components: { SrIcon },
    props: {
        closable: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        close() {
            this.$emit('input', false);
        },
    },
};
</script>
